import { message } from 'antd';
import store from 'store';
import { remove, findIndex } from 'lodash';
import { vendorContactCheck, getInternationalTelCode } from '../services/api';
import { guid, genFields } from '../utils/';
import { saveFinishedStep } from '../views/Register/Basic';
import { job } from '../constant/';
import { contactFields } from '../constant/fields';

function gen() {
  return {
    tempId: guid(),
    ...genFields(contactFields)
  };
}
function init() {
  const initalContactsData = job.map((value) => {
    return {
      ...gen(),
      job: {
        value: value.name,
      },
      isInit: true,
      editable: true
    };
  });
  return {
    contactsData: store.get('contacts') || initalContactsData,
    internationalTelCodes: [],
  };
}
export default {
  namespace: 'contactRegister',
  state: init(),
  effects: {
    *checkContacts({ payload: { history, data } }, { call }) {
      const res = yield call(vendorContactCheck, data);
      if (res.success) {
        saveFinishedStep(2);
        history.push('/register/basic/step-three');
      } else {
        res.msg && message.error(res.msg);
      }
    },
    *addContacts(action, { put }) {
      const tempId = guid();
      yield put({
        type: 'addContactsData',
        payload: { data: { tempId } },
      });
      return tempId;
    },
    *getInternationalTelCode(_, { call, put }) {
      const result = yield call(getInternationalTelCode);
      if (result.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              internationalTelCodes: result.data
            }
          }
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    },
    updateContacts(state, { payload: { data, cache } }) {
      const contactsData = [...state.contactsData];
      if (cache && data.mainFlag.value) {
        contactsData.forEach(value => value.mainFlag.value = false);
      }
      const index = findIndex(contactsData, { tempId: data.tempId });
      contactsData.splice(index, 1, data);
      cache && store.set('contacts', contactsData);
      return {
        ...state,
        contactsData
      };
    },
    addContactsData(state, { payload: { data: { tempId } } }) {
      const contactsData = [...state.contactsData];
      contactsData.push({
        ...gen(),
        tempId,
        isInit: false,
        editable: true
      });
      // store.set('contacts', contactsData);
      return {
        ...state,
        contactsData
      };
    },
    deleteContactsData(state, { payload: { data: { tempId } } }) {
      const contactsData = [...state.contactsData];
      remove(contactsData, { tempId });
      store.set('contacts', contactsData);
      return {
        ...state,
        contactsData
      };
    },
    clear() {
      return init();
    }
  }
};
